// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_dd5dd02","widgetRow":"_76ca0c8","widgetHeaderRow":"_d152d46"};